<ng-template matStepLabel>
  <span>111111</span>
</ng-template>
<button style="margin-top: 5px" *ngIf="hideRefresh === false" color="primary" mat-raised-button (click)="onRefreshClicked()" title="Refresh Preview Data">
    <mat-icon>cached</mat-icon>
    Refresh
</button>

<mat-expansion-panel *ngIf="hideOptions === false" style="margin-top: 16px;">
    <mat-expansion-panel-header>
      <mat-panel-title>
        Options
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div>
        <mat-form-field style="width: 100px">
            <mat-label>Max Rows</mat-label>
            <input matInput [(ngModel)]="maxRows">
        </mat-form-field>
    </div>
    <div style="margin-top: 16px;">
        <mat-form-field class="chip-list">
            <mat-label>Filters</mat-label>
            <mat-chip-grid #chipList aria-label="Column Filters">
              <mat-chip-row
                *ngFor="let filter of activeColumnFilters"
                [removable]="true"
                style="background-color: #1ea9d3"
                (removed)="removeFilter(filter)">
                {{filter}}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip-row>
              <input
                placeholder="New Column Filter..."
                #filterInput
                [formControl]="filterFormControl"
                [matAutocomplete]="auto"
                [matChipInputFor]="chipList"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                (matChipInputTokenEnd)="addFilter($event)">
            </mat-chip-grid>
            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onFilterSelected($event)">
              <mat-option *ngFor="let columnDef of viewModel.columns" [value]="columnDef">
                {{columnDef.targetColumnName}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
    </div>
  </mat-expansion-panel>

<!-- <div style="margin-top: 5px; display: flex; width: 100%; align-content: flex-end; "> <span *ngIf="displayedColumnInfos"> Number of Columns:  {{ displayedColumnInfos.length }} </span>
  <mat-progress-bar *ngIf="isGettingData | async" style="margin-left: auto; width: 200px;" mode="indeterminate"></mat-progress-bar>
</div> -->

<div style="display: flex; align-items: center; flex-wrap: wrap; padding-bottom: 6px;">
    <button *ngIf="dataSource" mat-raised-button color="primary" (click)="clearSortFilter()" style="margin-top: 2px; letter-spacing: normal;float:left;">Clear Sort & Filter ({{previewTypeName}})</button>
    <ng-content select="[copilot-header]"></ng-content>
    <mat-paginator #topPaginator (page)="onPageChanged($event, topPaginator)"
    *ngIf="dataSource" [length]="totalRows" [pageSize]="rowsPerPage" [pageSizeOptions]="pageSizeOptions" showFirstLastButtons="true">
    </mat-paginator>
</div>

<h1 style="color: lightgray" *ngIf="!dataSource" class="center">{{(isGettingData | async) ? "Please wait..." : noDataTitle}}</h1>
<div style="overflow-y: auto; width:100%; overflow-x: auto;">
<p *ngIf="activeSortsSet.length!=0 && previewType!='Summary'">
  <!-- {{activeSortsSet | json}} -->
  <span style="font-weight: bold;">Sort: </span> {{activeSortsSetString}}
</p> 
        
  <table *ngIf="dataSource" mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort matSortDisableClear (matSortChange)="announceSortChange($event)" [style]="widthOptions ? 'width: auto;' : ''">
      <div *ngIf="displayedColumnInfos">
      <ng-container  *ngFor="let colInfo of displayedColumnInfos; trackBy: trackByIndex; let i = index" matColumnDef="{{colInfo.index}}" >
          <th mat-header-cell *matHeaderCellDef="let element; let row" [ngClass]="getClassForRow(row, colInfo, displayedColumnInfos)" index="i" appMatTableColumnResize [style.width]="colInfo.width" [style.min-width]="colInfo.fixedWidth ? colInfo.width : null" [style.max-width]="colInfo.fixedWidth ? colInfo.width : null" style="text-align: left">
            <div style="display: flex; justify-content: space-between;">
              <!-- Remove filter and sort and rename header name specially for summary preview -->
              <ng-container *ngIf="colInfo.name.includes('smry_count'); else elsefilter">
                <!-- <span style="margin-right: 10px;"> count</span> -->
                <span mat-sort-header arrowPosition='after' (click)="sortData(colInfo.name)" style="display: block;text-align: left;margin-right: 10px;">count</span>
              </ng-container>
              <ng-template #elsefilter>
                <span *ngIf="colInfo.name=='row'; else elsesort" style="margin-right: 10px;">{{colInfo.name}}<ng-container *ngIf="showDataTypes"><br>({{colInfo.pydataType}})</ng-container><ng-container *ngIf="colInfo.selectedPartitionedColumn == colInfo.name"><span style="color: orange;">(P)</span></ng-container></span>
                <!-- <span #elsesort mat-sort-header arrowPosition='after' (click)="sortData(colInfo.name)">{{colInfo.name}}</span> -->
                <ng-template #elsesort>
                  <!-- <span mat-sort-header arrowPosition='after' (click)="sortData(colInfo.name)">{{colInfo.name}}</span>
                  <br>
                  <span style="display: block; text-align: left;">(object)</span> -->
                  <span mat-sort-header arrowPosition='after' (click)="sortData(colInfo.name)" style="display: block;">
                    <span style="display: block; text-align: left;">{{colInfo.name}}<ng-container *ngIf="showDataTypes"><br>({{colInfo.pydataType}})</ng-container><ng-container *ngIf="colInfo.selectedPartitionedColumn == colInfo.name"><br><span style="color: orange;">(P)</span></ng-container></span>
                  </span>
                </ng-template>
                <mat-icon [matMenuTriggerFor]="menu" #menuTrigger="matMenuTrigger" style="cursor: pointer; font-size: 16px" [ngClass]="{'primary-color-icon' : colInfo.filterActive}" (click)="showFilter(menuTrigger, colInfo.name)">filter_alt</mat-icon>
                <mat-menu #menu="matMenu" yPosition="below" style="margin-top: 2% !important;">
                  <app-column-filter [values]="filterValues" [columnFilterValues]="columnFilterValues" columnName="{{colInfo.name}}" (clearFilter)="onClearFilter($event)" (applyFilter)="onApplyFilter($event)" (closeFilter)="onCloseFilter()"></app-column-filter>
                </mat-menu>
              </ng-template>

            </div>
          </th>
          <td  mat-cell matTooltip={{element[colInfo.index]}} matTooltipClass="custom-mat-tooltip" nowrap *matCellDef="let element; let row" [ngClass]="getClassForRow(row, colInfo, displayedColumnInfos)" [style.width]="colInfo.width" [style.min-width]="colInfo.fixedWidth ? colInfo.width : null" [style.max-width]="colInfo.fixedWidth ? colInfo.width : null"> {{element[colInfo.index]}} </td>
      </ng-container>
    </div>
      <tr mat-header-row *matHeaderRowDef="displayedColumns" class="table-header" ></tr>
      <tr mat-row *matRowDef="let row; let i = index; columns: displayedColumns" [class.highlighted]="isRowSelected(row)" (click)="highlightRow(row, $event)"></tr>
  </table>
 
  <!-- <ejs-grid #previewgrid id='previewgrid' *ngIf="dataS" [dataSource]='dataS' 
  [allowFiltering]='true' [allowPaging]='true'[filterSettings]='filterOption' 
  [allowResizing]='true' min-height='90px' clipMode="EllipsisWithTooltip" [pageSettings]='initialPage'
  (dataBound)="dataBound($event)" (actionBegin)="actionBegin($event)">
  
    <e-columns>
      <e-column field='{{colInfo.index}}' headerText='{{colInfo.name}}' [allowFiltering]="colInfo.index!==0"
      *ngFor="let colInfo of displayedColumnInfos;" 
        minWidth='30' 
     ></e-column>
    </e-columns>
  </ejs-grid> -->
</div>

<!-- <mat-paginator #bottomPaginator (page)="onPageChanged($event, bottomPaginator)"
*ngIf="dataSource" [length]="totalRows" [pageSize]="rowsPerPage" [pageSizeOptions]="pageSizeOptions" showFirstLastButtons="true">
</mat-paginator> -->

<div class="paginator-container" *ngIf="dataSource">
  <div class="cache-info">
    {{ cacheFileCreationDtTime ? ('Data Cached On: ' + (cacheFileCreationDtTime | date:'dd-MMM-yyyy hh:mm a')) : '' }}
  </div>

  <mat-paginator
    #bottomPaginator
    (page)="onPageChanged($event, bottomPaginator)"
    [length]="totalRows"
    [pageSize]="rowsPerPage"
    [pageSizeOptions]="pageSizeOptions"
    showFirstLastButtons
    hidePageSize>
  </mat-paginator>
</div>
